import React from "react";
import "../css/team.css";
import Navbar from "../components/Navbar";
import Footer from '../components/Footer';
import BackToTop from '../components/BackToTop';
import PageHeader from "../components/PageHeader";
import KMataji from "../assets/Team/kuntidd.png";
import AjPrabhu from "../assets/Team/ajap.png";
import PPrabhu from "../assets/Team/psd.png";
import MPrabhu from "../assets/Team/md1.png";
import RMaharaj from "../assets/Team/RNSMaharaj.png";
import BMaharaj from "../assets/Team/BTSMaharaj.jpeg";
import Photo from "../assets/Team/photo-img.jpeg";

const teamMembers = [
    {
      name: "HG Ekavira Das",
      role: "Programs Coordinator",
      email: "radhanath@spiritual.org",
      image: Photo,
    },
    {
      name: "HG Vraja Lila Devi Dasi",
      role: "Programs Coordinator",
      email: "radhanath@spiritual.org",
      image: Photo,
    },
    {
      name: "HG Madhavacharya Das",
      role: "Senior Director",
      email: "radhanath@spiritual.org",
      image: MPrabhu,
    },
    {
      name: "HG Kunti Devi Dasi",
      role: "Director",
      email: "radhanath@spiritual.org",
      image: KMataji,
    },
    {
      name: "HG Prema Sindhu Das",
      role: "Programs Coordinator",
      email: "radhanath@spiritual.org",
      image: PPrabhu,
    },
    {
      name: "HG Prithu Das",
      role: "Programs Coordinator",
      email: "radhanath@spiritual.org",
      image: Photo,
    },
    {
      name: "HG Jadurani Devi Dasi",
      role: "Programs Coordinator",
      email: "radhanath@spiritual.org",
      image: Photo,
    },
    {
      name: "HG Aja Das",
      role: "Programs Coordinator",
      email: "radhanath@spiritual.org",
      image: AjPrabhu,
    },
    {
      name: "HG Chaitanya Kishore Das",
      role: "Programs Coordinator",
      email: "radhanath@spiritual.org",
      image: Photo,
    },
    {
      name: "HG Gopishvari Devi Dasi",
      role: "Programs Coordinator",
      email: "radhanath@spiritual.org",
      image: Photo,
    }

    // Add more team members as needed
  ];
  
  const featuredMembers = [
    {
        name: "H H Bhakti Tirtha Swami", 
        image: BMaharaj,
    },
    {
        name: "H H Radhanath Swami", 
        image: RMaharaj,
    },
  ];

  const TeamPage = () => {
    return (
      <>
        <Navbar />
        <PageHeader title="Meet The Local Team" path="/team" name="Meet The Local Team" />
        
        <div className="team-page">

          {/* New section for the two featured members (above the main team grid) */}
            <div className="team-grid featured-grid"> 
              {featuredMembers.map((member, index) => (
              <div className="team-card" key={index}>
                <img src={member.image} alt={member.name} className="m-image" />
                <h3 className="m-team">{member.name}</h3>
              </div>
            ))}
            </div>

          <div className="team-grid">
            {teamMembers.map((member, index) => (
              <div className="team-card" key={index}>
                <img src={member.image} alt={member.name} className="team-image" />
                <h3 className="team-name">{member.name}</h3>
                {/* <p className="team-role">{member.role}</p> */}
                {/* <a href={`mailto:${member.email}`} className="team-email">
                  {member.email}
                </a> */}
              </div>
            ))}
          </div>
        </div>
        <Footer />
        <BackToTop />
      </>
      
    );
  };

export default TeamPage;